const SPACING = {
  XXS: '4px',
  XS: '8px',
  S: '16px',
  M: '24px',
  L: '32px',
  XL: '40px',
}

export { SPACING }
